/**
 * @generated SignedSource<<ced0a6739432a230108889f4d0e09538>>
 * @relayHash 41fee47bcd447ee8e96835308a5a4f99
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cd95adfed4d8357af09a9ad201ca4d15932c64b4fa418a1b4a4c2e557e12c551

import type { ConcreteRequest } from 'relay-runtime';
export type usePopularLabelsDataSpaceIdQuery$variables = {
  spaceKey?: string | null;
};
export type usePopularLabelsDataSpaceIdQuery$data = {
  readonly space: {
    readonly id: string | null;
  } | null;
};
export type usePopularLabelsDataSpaceIdQuery = {
  response: usePopularLabelsDataSpaceIdQuery$data;
  variables: usePopularLabelsDataSpaceIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "usePopularLabelsDataSpaceIdQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePopularLabelsDataSpaceIdQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "41fee47bcd447ee8e96835308a5a4f99",
    "id": "cd95adfed4d8357af09a9ad201ca4d15932c64b4fa418a1b4a4c2e557e12c551",
    "metadata": {},
    "name": "usePopularLabelsDataSpaceIdQuery",
    "operationKind": "query",
    "text": "query usePopularLabelsDataSpaceIdQuery($spaceKey:String){space(key:$spaceKey){id}}"
  }
};
})();

(node as any).hash = "d5968c7370aba3bd3a9089e4721bb508";

export default node;
